import React from "react";
import { Drawer, Typography, Button, Box, IconButton } from "@mui/material";
import {
  Close as CloseIcon,
  CheckCircle as CheckCircleIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

function GitHubSuccessDrawer({
  open,
  onClose,
  repository,
  pullRequestNumber,
  pullRequestUrl,
}) {
  const navigate = useNavigate();

  const handleClose = () => {
    onClose();
  };

  const handleOKClick = () => {
    // Navigate to landing page
    navigate("/dashboard/test-automation");
    // Close the drawer
    onClose();
  };

  const handleViewRepository = () => {
    if (repository) {
      window.open(`https://github.com/${repository}`, "_blank");
    }
  };

  const handleViewPullRequest = () => {
    if (pullRequestUrl) {
      window.open(pullRequestUrl, "_blank");
    }
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={() => {}} // Prevent closing when clicking outside
      slotProps={{
        paper: {
          sx: {
            width: {
              xs: "90vw", // Mobile
              sm: "70vw", // Tablet
              md: "50vw", // Small laptops
              lg: "40vw", // Desktop
            },
            maxWidth: "600px",
            borderRadius: "8px 0 0 8px",
          },
        },
      }}
    >
      <Box
        sx={{
          p: { xs: 2, sm: 3 },
          display: "flex",
          flexDirection: "column",
          height: "100%",
          gap: "24px",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              color: "#666",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Content */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "24px",
            textAlign: "center",
          }}
        >
          {/* Success Icon */}
          <Box
            sx={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              backgroundColor: "#4CAF50",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 2,
            }}
          >
            <CheckCircleIcon
              sx={{
                fontSize: "40px",
                color: "white",
              }}
            />
          </Box>

          {/* Success Message */}
          <Typography
            variant="h5"
            sx={{
              fontFamily: "Manrope",
              fontWeight: 700,
              fontSize: "24px",
              color: "#000000",
              mb: 1,
            }}
          >
            Your Playwright TypeScript project is successfully pushed to GitHub
          </Typography>

          {/* Explanatory Text */}
          <Typography
            variant="body1"
            sx={{
              fontFamily: "Manrope",
              fontWeight: 400,
              fontSize: "16px",
              color: "#666666",
              lineHeight: 1.5,
              maxWidth: "400px",
            }}
          >
            You may now review the repository, manage branches, and collaborate
            with your team.
          </Typography>
        </Box>

        {/* Footer Buttons */}
        <Box
          sx={{
            display: "flex",
            gap: "16px",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          {/* OK Button */}
          <Button
            onClick={handleOKClick}
            variant="contained"
            sx={{
              width: "80px",
              height: "40px",
              borderRadius: "8px",
              borderWidth: "2px",
              padding: "8px 16px",
              backgroundColor: "#0094FB",
              color: "white",
              textTransform: "none",
              fontFamily: "Manrope",
              fontWeight: 700,
              fontSize: "16px",
              lineHeight: "20px",
              letterSpacing: "0.15px",
              "&:hover": {
                backgroundColor: "#0078D4",
              },
            }}
          >
            OK
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
}

export default GitHubSuccessDrawer;
